import ApiService from "./api.service";

class CertificationsService {
  async allCertifications(params) {
    return await ApiService.get(`/certifications?page=${params.page}&per_page=${params.per_page}`);
  }

  async createCertification(params) {
    return await ApiService.postMultipart(`/certifications`, params);
  }

  async deleteCertification(id) {
    return await ApiService.delete(`/certifications/${id}`);
  }
  async sendNotifications() {
    return await ApiService.get(`/certifications/send_notifications`);
  }
}

export default new CertificationsService();
